import theme from '../../../styles/PageTheme';
import style from '../../../styles/PageStyles.js';
import { Typography, Link } from '@uhc-tempo/components';
import displayLoadingIndicator from '../../../common/components/LoadingIndicator.components';
import parse from 'html-react-parser';

const classes = style(theme);

const disclaimerStyles = {
    disclaimerTitle: {
        color: '#1976d2',
        fontSize: '20px',
    },
    disclaimerSubSection: {
        marginRight: '30px',
        marginTop: '15px',
    },
};

const isEstimateScreen = false;

export default function DisclaimersText(props) {
    const { genericDisclaimers } = props;

    if (genericDisclaimers) {
        return (
            <div id="disclaimers-modal-content">
                {genericDisclaimers.map((genericDisclaimer, index) => (
                    <div style={classes.marginBottom20} key={`section-${index}`}>
                        <Typography.H3
                            component={'span'}
                            sx={classes.bold}
                            key={`disclaimerTitle-${index}`}
                            data-testid={`disclaimerTitle-${index}`}
                            style={disclaimerStyles.disclaimerTitle}
                        >
                            {genericDisclaimer.title}
                        </Typography.H3>
                        {genericDisclaimer.subSections.map((subSection, indexy) => (
                            <div
                                style={disclaimerStyles.disclaimerSubSection}
                                key={`subSection-${indexy}`}
                            >
                                {subSection.text.length > 1 && (
                                    <>
                                        <Typography.Paragraph
                                            component={'span'}
                                            key={`disclaimerSubtitle-${indexy}`}
                                            data-testid={`disclaimerSubtitle-${indexy}`}
                                            sx={classes.bold}
                                        >
                                            {subSection.subTitle}
                                        </Typography.Paragraph>
                                        <ul>
                                            {subSection.text.length > 1 &&
                                                subSection.text.map((text, indexz) => (
                                                    <li
                                                        key={`disclaimerBullet-${indexz}`}
                                                        sx={{ display: 'list-item' }}
                                                    >
                                                        <Typography.Paragraph>
                                                            {' '}
                                                            {text}
                                                        </Typography.Paragraph>
                                                    </li>
                                                ))}
                                        </ul>
                                    </>
                                )}
                                {subSection.text.length === 1 && (
                                    <div>
                                        <Typography.Paragraph
                                            component={'span'}
                                            key={`disclaimerText-${indexy}`}
                                            data-testid={`disclaimerText-${indexy}`}
                                        >
                                            <b>
                                                {subSection.text.length === 1 &&
                                                    subSection.subTitle}
                                            </b>{' '}
                                            {subSection.text.length === 1 &&
                                                parse(subSection.text[0])}
                                            {subSection.text?.[0].trim().endsWith('visit') && (
                                                <>
                                                    <Link
                                                        externalLink
                                                        href="http://justplainclear.com/"
                                                        size="medium"
                                                        text="justplainclear.com"
                                                    />
                                                    {'.'}
                                                </>
                                            )}
                                        </Typography.Paragraph>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    } else {
        return displayLoadingIndicator(isEstimateScreen);
    }
}
